(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gb-school-interest"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const requested = new URLSearchParams(window.location.search).get('interest');
    if (!requested) return;
    const select = document.querySelector('#GbSchoolInterest-product-interest');
    if (!select || !Array.from(select.options).some((option) => option.value === requested)) return;
    select.value = requested;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });
  } catch(e) { console.error(e); }
})();

})();
